module.exports = __webpack_public_path__ + "images/emoji/point_up.9edd48e736496eaa7c37.png";